module.exports = __webpack_public_path__ + "img/tracee_d.b6fa3189.png";